import React, { useState } from 'react';
import SearchComponent from '../components/SearchVerificationDebts/SearchComponent';
import TableDebtComponent from '../components/SearchVerificationDebts/TableDebtComponent';
import TableDiscountComponent from '../components/SearchVerificationDebts/TableDiscountComponent ';
import AddDiscountButton from '../components/SearchVerificationDebts/AddDiscountButton';
import { useAuthContext } from '../context/AuthContext';
import AddDebtModal from '../components/SearchVerificationDebts/addDebtModal';
import {
  debtColumns,
  kedeDebtDiscountColumns,
} from '../components/SearchVerificationDebts/VerificationDebtsColumns';
import axios from 'axios';

const SearchVerificationDebts = () => {
  const [selectedYear, setSelectedYear] = useState('');
  const { setLoading, setNotification } = useAuthContext();
  const [data, setData] = useState(null);
  const [modalSubmit, setModalSubmit] = useState(false);
  const [openAddDebtModal, setOpenAddDebtModal] = useState(false);
  const [afm, setAfm] = useState('');
  const [afmError, setAfmError] = useState('');
  const [debtToDelete, setDebtToDelete] = useState({ amount: null, id: null });

  const handleSearch = async () => {
    try {
      setLoading(true);
      setDebtToDelete({ amount: null, id: null });
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/getVerificationsDebts`,
        {
          year: selectedYear,
          afm: afm,
        },
        {
          withCredentials: true,
        },
      );
      if (response.data) {
        if (response.data.length > 1) {
          setNotification({
            message: 'Βρέθηκαν παραπάνω απο μία Βεβαιώσεις',
            color: 'info',
            open: true,
          });
        }
        setData(response.data);
      } else {
        setNotification({
          open: true,
          color: 'error',
          message: `Δεν βρέθηκε οφειλή με το συγκεκριμένο ΑΦΜ το έτος ${selectedYear} `,
        });
      }
    } catch (error) {
      if (error.name === 'ValidationError' && error.errors) {
        setAfmError(error.errors[0]);
      } else {
        setAfmError('');
      }
    } finally {
      setLoading(false);
    }
  };

  const handleConfirmation = async (formData) => {
    try {
      setLoading(true);

      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/addDiscountData`,
        {
          ...formData,
          amount: debtToDelete.amount,
          id: debtToDelete.id,
        },
        { withCredentials: true },
      );

      await handleSearch();

      setModalSubmit(!modalSubmit);
      setNotification({
        open: true,
        message: response.data.message,
        color: 'success',
      });
    } catch (error) {
      setNotification({
        message: error.response?.data.message,
        open: true,
        color: 'error',
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        overflow: 'auto',
        alignItems: 'center',
        width: '100vw',
      }}
    >
      <div style={{ flexGrow: '1', position: 'relative' }}>
        <h2>Αναζήτηση και Αποβεβαίωση Οφειλών</h2>

        <SearchComponent
          selectedYear={selectedYear}
          setSelectedYear={setSelectedYear}
          data={data}
          setData={setData}
          afm={afm}
          afmError={afmError}
          setAfmError={setAfmError}
          setAfm={setAfm}
          modalSubmit={modalSubmit}
          handleSearch={handleSearch}
        />
      </div>
      {data?.length > 0 && (
        <>
          <div className='deleteParent'>
            {data.map((it, index) => (
              <div className='deleteComponent' key={index}>
                <h3>Οφειλή {it.debt.company_subscr_id}</h3>

                <TableDebtComponent
                  key={index}
                  columns={debtColumns}
                  results={[it.debt]}
                />
                <div style={{ paddingTop: '2rem' }}>
                  <h3>Αποβεβαιώσεις</h3>

                  {it.discounts && it.discounts?.length > 0
                    ? (
                      <TableDiscountComponent
                        columns={kedeDebtDiscountColumns}
                        results={it.discounts}
                      />
                    )
                    : (
                      <>
                        <div>Δεν Βρέθηκαν Αποβεβαιώσεις</div>
                      </>
                    )}
                  <AddDiscountButton
                    disabled={
                      it.debt.amount ==
                        it.discounts.reduce(
                          (sum, obj) => sum + obj.discount_amount,
                          0,
                        ) || it.debt.status != 2
                    }
                    setOpenAddDebtModal={setOpenAddDebtModal}
                    amount={it.debt.rest_amount}
                    debtId={it.debt.id}
                    setDebtToDelete={setDebtToDelete}
                  />
                </div>

                {debtToDelete.id && (
                  <AddDebtModal
                    setDebtToDelete={setDebtToDelete}
                    amount={debtToDelete.amount}
                    debtId={debtToDelete.id}
                    handleConfirmation={handleConfirmation}
                    open={openAddDebtModal}
                    setOpen={setOpenAddDebtModal}
                  />
                )}
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default SearchVerificationDebts;
